import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Mail } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) { toast.success("Welcome back!"); nav("/admin/dashboard"); }
    else toast.error(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A2540] p-6" data-testid="admin-login-page">
      <div className="absolute inset-0 hero-grid opacity-30 pointer-events-none" />
      <div className="w-full max-w-md p-8 rounded-2xl bg-white shadow-2xl relative">
        <div className="flex items-center gap-2.5 mb-6">
          <div className="w-10 h-10 bg-[#2563EB] hex-clip flex items-center justify-center relative">
            <div className="w-10 h-10 scale-[0.7] bg-[#0A2540] hex-clip absolute inset-0 m-auto" />
            <span className="relative text-white font-extrabold text-lg z-10" style={{ fontFamily: "Outfit" }}>E</span>
          </div>
          <div>
            <div className="font-extrabold text-[#0A2540]" style={{ fontFamily: "Outfit" }}>EASYWORKS</div>
            <div className="text-[9px] tracking-[0.2em] text-slate-500 font-semibold">ADMIN PANEL</div>
          </div>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-1" style={{ fontFamily: "Outfit" }}>Welcome back</h1>
        <p className="text-[13px] text-slate-500 mb-6">Sign in to manage your website.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <Label htmlFor="a-email" className="flex items-center gap-1.5"><Mail className="w-3.5 h-3.5" />Email</Label>
            <Input id="a-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
          </div>
          <div>
            <Label htmlFor="a-pass" className="flex items-center gap-1.5"><Lock className="w-3.5 h-3.5" />Password</Label>
            <Input id="a-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
          </div>
          <Button type="submit" disabled={submitting} className="w-full bg-[#2563EB] hover:bg-[#1D4ED8]" data-testid="admin-login-button">
            {submitting ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
